import React from 'react';


const ModalContext = React.createContext<{
  disabled?: boolean;
  loading?: boolean;
}>({ disabled: false, loading: false });


export const ModalProvider = ModalContext.Provider;


export const useModalContext = () => {
  return React.useContext(ModalContext);
};
